module.exports = __webpack_public_path__ + "static/media/t9.ae8f6bcd.jpg";